(() => {
  const dialog = document.getElementById('FogattiAdvisorDialog');
  let trigger = null;
  const setExpanded = value => document.querySelectorAll('[data-fg-advisor-open][aria-expanded]').forEach(link => link.setAttribute('aria-expanded', String(value)));
  async function open(event) {
    const link = event.target.closest('[data-fg-advisor-open]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!dialog) {
      const panel = document.querySelector('[data-fg-rv-advisor]');
      if (panel) { event.preventDefault(); panel.scrollIntoView({ block: 'start' }); panel.querySelector('input,button')?.focus({ preventScroll: true }); }
      return;
    }
    if (typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    trigger = link;
    const navigation = link.closest('navigation-drawer');
    if (navigation?.open && typeof navigation.hide === 'function') await navigation.hide();
    if (dialog.open) return;
    dialog.showModal();
    document.documentElement.classList.add('fg-advisor-is-open');
    setExpanded(true);
    dialog.dispatchEvent(new CustomEvent('fogatti:advisor:open', { bubbles: true }));
    requestAnimationFrame(() => dialog.querySelector('[data-fg-advisor-close]')?.focus({ preventScroll: true }));
  }
  document.addEventListener('click', open);
  if (!dialog) return;
  dialog.querySelector('[data-fg-advisor-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('fg-advisor-is-open');
    setExpanded(false);
    const sourceDrawer = trigger?.closest('navigation-drawer');
    const target = trigger?.getClientRects().length && (!sourceDrawer || sourceDrawer.open) ? trigger : document.querySelector('[aria-controls="header-sidebar-menu"]');
    target?.focus({ preventScroll: true });
  });
})();
